import type { PropsWithChildren } from "react";

export const CenterSlot = ({ children }: Readonly<PropsWithChildren>) => (
  <div
    className="flex min-w-0 items-center justify-center"
    data-testid="header-v4-center-slot"
  >
    {children}
  </div>
);

CenterSlot.displayName = "HeaderWrapper.CenterSlot";
